import axios from 'axios';
import config from '../config/config';
import {
    SUPPORTER_COMMENTS_REQUEST,
    SUPPORTER_COMMENTS_RECEIVE,
    SUPPORTER_COMMENTS_ADD,
    SUPPORTER_COMMENTS_ADD_EDIT_TEXT_CHANGE,
    SUPPORTER_COMMENTS_ADD_SEND,
    SUPPORTER_COMMENTS_ADD_RECEIVE,
    SUPPORTER_COMMENTS_ADD_RECEIVE_ERROR,
    SUPPORTER_COMMENTS_UNDO_ADD_EDIT,
    SUPPORTER_COMMENTS_DELETE_REQUEST
} from '../config/actions';

export function getComments(id) {
    return dispatch => {
        dispatch({
            type: SUPPORTER_COMMENTS_REQUEST
        });
        axios(config.server.endpoint + 'backend/supporter/comments/' + id, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                dispatch({
                    type: SUPPORTER_COMMENTS_RECEIVE,
                    data: {
                        id: id,
                        comments: response.data.comments
                    }
                });
            }
        })
    }
}

export function addComment() {
    return {
        type: SUPPORTER_COMMENTS_ADD
    }
}

export function changeAddEditText(message) {
    return {
        type: SUPPORTER_COMMENTS_ADD_EDIT_TEXT_CHANGE,
        message: message
    }
}

export function saveAddEditComment(data) {
    if(data.edit) {

    }
    else if(data.add) {
        return dispatch => {
            dispatch({
                type: SUPPORTER_COMMENTS_ADD_SEND
            });
            axios(config.server.endpoint + 'backend/supporter/comment/' + data.supporterId, {
                method: 'post',
                data: {
                    message: data.message
                }
            }).then((response) => {
                if (response.status === 200) {
                    if (response.data.success === true) {
                        dispatch(getComments(data.supporterId));
                        dispatch({
                            type: SUPPORTER_COMMENTS_ADD_RECEIVE
                        });
                    } else {
                        dispatch({
                            type: SUPPORTER_COMMENTS_ADD_RECEIVE_ERROR,
                            data: response.data
                        });
                    }
                }
            });
        }
    }
}

export function undoAddEditComment() {
    return {
        type: SUPPORTER_COMMENTS_UNDO_ADD_EDIT
    }
}

export function deleteComment(data) {
    return dispatch => {
        dispatch({
            type: SUPPORTER_COMMENTS_DELETE_REQUEST,
            data: data
        });
        axios(config.server.endpoint + 'backend/supporter/comment/' + data.supporterId + '/' + data.commentId, {
            method: 'delete'
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    dispatch(getComments(data.supporterId));
                }
            }
        });
    }
}

export function bookmarkComment(data) {
    return dispatch => {
        axios(config.server.endpoint + 'backend/supporter/comment/bookmark/' + data.supporterId, {
            method: 'post',
            data: {
                commentId: data.commentId,
                isPinned: data.isPinned
            }
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    dispatch(getComments(data.supporterId));
                } 
            }
        });
    }
}